import { supabase } from '../supabaseClient';

// Rol / posiciones de un torneo, solo lectura. RPCs SECURITY DEFINER (Task #4 A2):
// las usa tanto la organizadora como el club con licencia (invitacion aceptada);
// el gate interno (_torneo_lectura_permitida) filtra el acceso server-side.

export async function getJornadasTorneo(torneoId) {
  const { data, error } = await supabase.rpc('get_jornadas_torneo', { p_torneo_id: torneoId });
  return { data: data || [], error };
}

// Detalle (ventana) de cada jornada: numero, nombre, fecha, hora_inicio, hora_fin, sede, num_campos.
export async function getJornadasDetalle(torneoId) {
  const { data, error } = await supabase.rpc('get_jornadas_detalle', { p_torneo_id: torneoId });
  return { data: data || [], error };
}

export async function getRolJornada(torneoId, jornada) {
  const { data, error } = await supabase.rpc('get_rol_jornada', { p_torneo_id: torneoId, p_jornada: jornada });
  return { data: data || [], error };
}

// Sedes del torneo (nombre, direccion, mapa, canchas), gateada por _torneo_lectura_permitida:
// la organizadora y los clubes del torneo. Misma forma que en Torneos.
export async function getSedesTorneo(torneoId) {
  const { data, error } = await supabase.rpc('get_sedes_torneo', { p_torneo_id: torneoId });
  return { data: data || [], error };
}

// Cabecera del torneo (nombre, sede, liga) para el flyer/rol del club, gateada por
// _torneo_lectura_permitida (el club participante no puede leer `ligas` por RLS).
export async function getTorneoCabecera(torneoId) {
  const { data, error } = await supabase.rpc('get_torneo_cabecera', { p_torneo_id: torneoId });
  return { data: (data && data[0]) || null, error };
}

// Con convocatoriaId filtra por division (categoria + genero, 20261005); sin ella, por
// categoria como antes (que mezcla divisiones si la categoria tiene varias).
export async function getTablaPosiciones(torneoId, categoriaId, convocatoriaId = null) {
  const params = { p_torneo_id: torneoId, p_categoria_id: categoriaId || null };
  if (convocatoriaId) params.p_convocatoria_id = convocatoriaId;
  const { data, error } = await supabase.rpc('get_tabla_posiciones', params);
  return { data: data || [], error };
}

export async function getBracket(torneoId, categoriaId, convocatoriaId = null) {
  const params = { p_torneo_id: torneoId, p_categoria_id: categoriaId || null };
  if (convocatoriaId) params.p_convocatoria_id = convocatoriaId;
  const { data, error } = await supabase.rpc('get_bracket', params);
  return { data: data || [], error };
}

export async function getTablaGrupos(torneoId, categoriaId, convocatoriaId = null) {
  const params = { p_torneo_id: torneoId, p_categoria_id: categoriaId || null };
  if (convocatoriaId) params.p_convocatoria_id = convocatoriaId;
  const { data, error } = await supabase.rpc('get_tabla_grupos', params);
  return { data: data || [], error };
}
